import React, { useEffect } from "react";
import { Link, useStaticQuery, graphql } from "gatsby"
import { ImageModule } from "../../../modules/Image_Module";
import $ from "jquery";

const SimilarPropertiesNegoDetails = (props) => {

    const { glstrapi } = useStaticQuery(graphql`
        query SimilarPropsNegoDetailsQuery {
            glstrapi {
                peoples(limit: -1) {
                    id
                    Name
                    Email_ID
                    Nego_Id
                    Phone_Number
                    URL
                    Image { url alternativeText }
                    imagetransforms
                    ggfx_results { id content_type transforms src_import_url src_cftle field }
                }
            }
        }
    `)
    const allPeoples = glstrapi?.peoples || [];

    const email = props?.NegoDetails?.[0]?.email;
    const negoPerson = email
        ? allPeoples.find(p => p.Email_ID?.toLowerCase().includes(email.toLowerCase()))
        : null;

    const negoIdStr = props?.NegoName && typeof props.NegoName === 'string'
        ? props.NegoName.split('/')?.[0]
        : null;
    const negoPersonAuction = negoIdStr
        ? allPeoples.find(p => p.Nego_Id === negoIdStr || p.Nego_Id === String(negoIdStr))
        : null;

    const resolvedPerson = negoPersonAuction || negoPerson;
    const nego_info = resolvedPerson ? { peoples: [resolvedPerson] } : null;

    useEffect(() => {
        $("a").each(function() {
            if($(this)){
                var get_href = $(this).attr('href');
                var remove_unde = get_href ? get_href.replace('undefined','') : "";
                remove_unde && $(this).attr('href', remove_unde);
            }
        });
    }, [])

    return (
        nego_info?.peoples?.length > 0 &&
        <div className="contact-person mt-3">
            <div className="contact-img">
                <picture>
                    <ImageModule ImageSrc={nego_info?.peoples[0]?.Image} altText={nego_info?.peoples[0]?.Name + " - Strettons"} ggfx_results={nego_info?.peoples[0]?.ggfx_results} strapi_id={nego_info?.peoples[0]?.id} imagename="peoples.Image.team_avatar"  />
                </picture>
            </div>
            <div className="contact-info">
                <h3>{nego_info?.peoples[0]?.Name}</h3>
                <a href={"tel:" + nego_info?.peoples[0]?.Phone_Number} className="tel">
                    {nego_info?.peoples[0]?.Phone_Number}
                </a>
                <a href={"javascript:;"} onClick={()=>props.MemberPopup(nego_info?.peoples[0], "Member_Form")} className="mail"> / Email</a>
            </div>
        </div>
    )
}

export default SimilarPropertiesNegoDetails
